import {Dispatch} from "redux";
import * as uuid from "uuid";
import {
    ADD_SHORTLIST,
    ADD_SOURCE as ADD,
    EDIT_SOURCE,
    REMOVE_SHORTLIST,
    REMOVE_SOURCE
} from '../action_types/ioActionTypes';
import {
    ADD_SOURCE,
    DELETE_SOURCES,
    DESELECT_ALL,
    RESET,
    SELECT_ALL,
    SHORTLIST_ADD,
    SHORTLIST_REMOVE,
    TOGGLE_SELECT,
    UPDATE_SOURCE
} from "../action_types/literatureWizardActionTypes";

import IShortlistable from "../interfaces/IShortlistable";
import ISource from "../interfaces/ISource";

import * as bibtex from "bibtex-parse-js";
import {t} from 'react-multi-lang';
import {createSource} from "../utils/extractBibtex";
import {showNotification} from "./notificationActions";

export function addSource(source: ISource, socket: SocketIOClient.Socket) {
    return (dispatch: Dispatch) => {
        source._id = uuid.v1();
        source.old_id = source._id;

        socket.emit(ADD, source);

        dispatch({
            source,
            type: ADD_SOURCE
        });

        showNotification(t('notification.new_source'))(dispatch);
    };
}

export function updateSource(rawSource: ISource) {
    return (dispatch: Dispatch, getState: any) => {
        const source: ISource = {
            ...rawSource,
            authors: rawSource.authors
                .map((a: string) => a.trim())
                .filter((a: string) => a !== ''),
            keywords: rawSource.keywords
                .map((k: string) => k.trim())
                .filter((k: string) => k !== ''),
            year: parseInt(rawSource.year.toString(), 10),
        };

        dispatch({
            source,
            type: UPDATE_SOURCE
        });

        const {io} = getState();
        io.socket.emit(EDIT_SOURCE, source);
    };
}

export function parseUploadedFiles(files: FileList, history: any) {
    return (dispatch: Dispatch, getState: any) => {
        asyncParse(files)(dispatch, getState)
            .then(() => history.push(`/overview`))
            .catch(console.log); // tslint:disable-line
    };
}

function asyncParse(files: FileList) {
    return async (dispatch: Dispatch, getState: any) => {
        for (let index = 0; index < files.length; ++index) {
            const file = files.item(index);

            if (file == null) {
                return;
            }

            const fileString = await parseFileString(file);
            const fileArray = file.name.split(".");
            const extension = fileArray[fileArray.length - 1].toUpperCase();
            const socket = getState().io.socket;

            if (extension === "JSON") {
                const sourceObject: { references: ISource[] } = JSON.parse(fileString);

                if (sourceObject === undefined || sourceObject.references === undefined) {
                    return;
                }
                for (const source of sourceObject.references) {
                    addSource(source, socket)(dispatch);
                }
            } else if (extension === "BIB") {
                const sourceArray = bibtex.toJSON(fileString);

                for (const source of sourceArray) {
                    const parsedSource = createSource(source);
                    addSource(parsedSource, socket)(dispatch);
                }
            }

        }
    };
}

async function parseFileString(file: File) {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = (event: any) => resolve(event.currentTarget.result);
        reader.onerror = (error: any) => reject(error);
        reader.readAsText(file);
    });
}

export function shortlistAdd(elementType: IShortlistable, value: any) {
    return (dispatch: Dispatch, getState: any) => {
        if (value === '' || value === undefined) {
            return;
        }

        const socket = getState().io.socket;
        socket.emit(ADD_SHORTLIST, {type: elementType, value});

        dispatch({
            elementType,
            type: SHORTLIST_ADD,
            value
        });

        showNotification(`"${value}" ${t('notification.shortlist_added')}`)(dispatch);
    };
}

export function shortlistRemove(elementType: IShortlistable, value: any) {
    return (dispatch: Dispatch, getState: any) => {
        const socket = getState().io.socket;
        socket.emit(REMOVE_SHORTLIST, {type: elementType, value});

        dispatch({
            elementType,
            type: SHORTLIST_REMOVE,
            value
        });

        showNotification(`"${value}" ${t('notification.shortlist_removed')}`)(dispatch);
    };
}

export function resetSources() {
    return (dispatch: Dispatch) => {
        dispatch({
            type: RESET,
        });
    };
}

export function toggleSelect(id: string) {
    return (dispatch: Dispatch) => {
        dispatch({
            id,
            type: TOGGLE_SELECT,
        });
    };
}

export function selectAll(ids: string[]) {
    return (dispatch: Dispatch) => {
        dispatch({
            ids,
            type: SELECT_ALL,
        });
    };
}

export function deselectAll(ids: string[]) {
    return (dispatch: Dispatch) => {
        dispatch({
            ids,
            type: DESELECT_ALL,
        });
    };
}

export function deleteSources(ids: string[]) {
    return (dispatch: Dispatch) => {
        dispatch({
            ids,
            type: DELETE_SOURCES,
        });
    };
}

export function deleteSelectedSources() {
    return (dispatch: Dispatch, getState: any) => {
        const {io, literature} = getState();

        deleteSources(literature.selected)(dispatch);
        deselectAll(literature.selected)(dispatch);

        io.socket.emit(REMOVE_SOURCE, literature.selected);

        showNotification(`${literature.selected.length} ${t('notification.deleted_source')}`)(dispatch);
    };
}



// WEBPACK FOOTER //
// ./src/actions/literatureWizardActions.ts